// generated by srcset-codegen
import src from "./robin-wordmark.png";

const width = 1140;
const height = 345;
export default { src, width, height };
